if (!customElements.get('categories-carousel')) {
  customElements.define(
    'categories-carousel',
    class CategoriesCarousel extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.flickity = null;
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-flickity-config]');
        if (!this.slider) return;

        this.initFlickity();
        this.setupThemeEditorEvents();
      }

      disconnectedCallback() {
        this.flickity?.destroy();
      }

      initFlickity() {
        const config = JSON.parse(this.slider.dataset.flickityConfig || '{}');

        this.flickity = new Flickity(this.slider, {
          cellAlign: 'left',
          contain: true,
          groupCells: true,
          freeScroll: true,
          prevNextButtons: true,
          pageDots: false,
          ...config,
        });

        this.flickity.on('ready', () => this.checkNavigationVisibility());
        this.flickity.on('resize', () => this.checkNavigationVisibility());
      }

      checkNavigationVisibility() {
        if (!this.flickity) return;

        const buttons = this.slider.querySelectorAll('.flickity-button');
        const needsNavigation = this.flickity.slides.length > 1;

        buttons.forEach((btn) => {
          btn.classList.toggle('lg:flex', needsNavigation);
          btn.classList.toggle('!hidden', !needsNavigation);
        });
      }

      setupThemeEditorEvents() {
        if (!Shopify.designMode) return;

        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(this)) {
            this.flickity?.destroy();
            this.initFlickity();
          }
        });
      }
    }
  );
}
